<script setup lang="ts">

import { AppInput } from '@shared/ui/inputs'
import { CardAdmin } from '@shared/ui/cards'
import { BtnPrimary } from '@shared/ui/buttons'

import { useHelperAction } from '../../api/helpers/action.hook'

defineOptions({
  name: 'HelperPushCard',
})

const oneMinute = useHelperAction()
const tenMinutes = useHelperAction()

const refBookingId1m = ref<string | number>('')
const refBookingId10m = ref<string | number>('')

const send1m = async (): Promise<void> => {
  const ok = await oneMinute.run('admin.helpers.push.1m', { booking_id: Number(refBookingId1m.value) })

  if (ok) {
    refBookingId1m.value = ''
  }
}

const send10m = async (): Promise<void> => {
  const ok = await tenMinutes.run('admin.helpers.push.10m', { booking_id: Number(refBookingId10m.value) })

  if (ok) {
    refBookingId10m.value = ''
  }
}
</script>

<template>
  <CardAdmin
    title="Push notification"
    fullwidth
  >
    <div class="helper-push">
      <div class="helper-push__row">
        <span class="helper-push__label">1m:</span>
        <AppInput
          v-model="refBookingId1m"
          type="number"
          placeholder="Enter booking id"
        />
        <BtnPrimary
          text="send"
          :disabled="!oneMinute.canRun.value || oneMinute.isRunning.value || !refBookingId1m"
          @click="send1m"
        />
      </div>
      <div class="helper-push__row">
        <span class="helper-push__label">10m:</span>
        <AppInput
          v-model="refBookingId10m"
          type="number"
          placeholder="Enter booking id"
        />
        <BtnPrimary
          text="send"
          :disabled="!tenMinutes.canRun.value || tenMinutes.isRunning.value || !refBookingId10m"
          @click="send10m"
        />
      </div>
    </div>
  </CardAdmin>
</template>

<style scoped lang="scss" src="./HelperPushCard.scss" />
